
<div class="row" style="height: 100% !important; font-size: 14px">

  <div class="col-5">

    <div class="fdm-big-choice-box">

      <!-- selectedOption<br>
      <textarea style="width:100%;height:200px;font-size:11px;">{{ selectedOption | json }}</textarea> -->
      
      <ng-container *ngIf="!isGroundControlPoints">
        <label id="pick-coords-from">{{ 'MAP.PHOTOGRAM.COORDINATES_SOURCE' | translate }}</label>
        <mat-radio-group
          aria-labelledby="pick-coords-from"
          class="pick-radio-group"
          [(ngModel)]="useCoordsFrom">
          <mat-radio-button class="pick-radio-button" value="images" (click)="resetDataFromFolder()">
            {{ 'MAP.PHOTOGRAM.COORDINATES_IMAGES' | translate }} / <span class="fdm-linked" style="text-decoration:underline;">{{ 'GENERIC.RESET' | translate }}</span>
          </mat-radio-button>
          <mat-radio-button class="pick-radio-button" value="file">
            {{ 'MAP.PHOTOGRAM.COORDINATES_FILES' | translate }}
          </mat-radio-button>
        </mat-radio-group>
      </ng-container>
      
      <ng-container *ngIf="isGroundControlPoints">
        <label id="pick-coords-from">
          {{ 'MAP.PHOTOGRAM.IMPORT_COORDINATES' | translate }} 
          <span style="font-size:11px">(<span class="fdm-linked" (click)="fileReset()" style="text-decoration:underline;">{{ 'MAP.PHOTOGRAM.COORDINATES_RESET' | translate }}</span>)</span>
        </label>
      </ng-container>

      <div style="margin-left:28px;vertical-align:top;" *ngIf="useCoordsFrom !== 'images' || isGroundControlPoints">

        <input readonly="true" type="text" [value]="fileName" [placeholder]="fileName == null ? 'No file selected' : ''">

        <button class="fdm-button" mat-flat-button color="primary" (click)="fileInput.click()" [matTooltip]="'MAP.PHOTOGRAM.UPLOAD_TOOLTIP' |  translate" >
          <fa-icon icon="folder-open"></fa-icon> {{ 'MAP.PHOTOGRAM.OPEN_FILE' | translate }}
        </button>
      
        <input hidden type="file" accept=".txt,.csv"  (change)="uploadFiles($event); fileInput.value = null;" #fileInput>

        <div *ngIf="fileName !== null && this.currentJob['CsvCoordsDifferentCRS']" class="fdm-big-choice-box" style="margin-top:15px;">
          <label id="pick-coords-from">{{ 'MAP.PHOTOGRAM.CONVERT_COORDINATES' | translate }} </label>
          <p>{{ 'MAP.PHOTOGRAM.EPSG_SYSTEM' | translate }}</p>
          <div>
            <input readonly="true" style="width:60%;" [value]="selectedOption ? ( (selectedOption && selectedOption['uid'] && selectedOption.uid) !== '4326' ? selectedOption.name : '' ) : ''" type="text" matInput>
          <!-- <mat-autocomplete (optionSelected)="myOptionSelected()" [displayWith]="displayFn.bind(this)" #matAutocomplete="matAutocomplete">
            <mat-option *ngFor="let option of options" [value]="option">{{ option.name }}</mat-option>
          </mat-autocomplete> -->
    
            <button *ngIf="!DATA_FROM_FOLDER" class="fdm-button" mat-flat-button color="primary" (click)="selectEPSGCode()" > 
              <fa-icon icon="map-marker-question"></fa-icon> &nbsp;{{ 'GENERIC.SELECT' | translate }}
            </button>
          </div>
        </div>

        <p style="font-size:11px;color:#555;"><span class="fdm-count-inv">{{ 'GENERIC.NOTE' | translate }}</span> {{ 'MAP.PHOTOGRAM.VERTICAL_REFERENCE' | translate }} </p>


        <div *ngIf="currentJob['importedRowXYZ'] && ! currentJob['originalRowXYZ']" class="fdm-big-choice-box" style="margin-top:15px;">
          <p><span class="fdm-count-inv">{{ 'GENERIC.NOTE' | translate }}</span> {{  'MAP.PHOTOGRAM.REORDER_COORDINATES' | translate }}</p>
          <div>
            <span translate class="fdm-checkboxes">
              <input id="latlong" type="checkbox" class="fdm-checkbox" [(ngModel)]="currentJob['latLongSwap']" (change)="latLongSwapping()" />
              <label for="latlong"></label>
              <small style="margin-top:-6px!important;">MAP.PHOTOGRAM.REVERSE_ORDER</small>
            </span>
          </div>
        </div>

      </div>

    </div>
   
    <div class="fdm-big-choice-box">
      <label>{{ 'MAP.PHOTOGRAM.COORDINATES_ACCURACY' | translate }}</label>
      <p>{{ 'MAP.PHOTOGRAM.COORDINATES_METHOD' | translate }}</p>
      <mat-form-field>
        <input matInput style="width:160px;" class="form-control"  type="number" #latAccuracy (change)="applyAccuracy(latAccuracy.value, undefined, undefined )" [placeholder]="
        (CSRType !== 'Projected' ? 'MAP.PHOTOGRAM.LATITUDE_ACCURACY' : 'MAP.PHOTOGRAM.Y_ACCURACY') | translate "/>
      </mat-form-field>
      <mat-form-field>
        <input matInput style="width:160px;" type="number" class="form-control"  #longAccuracy (change)="applyAccuracy(undefined, longAccuracy.value, undefined)"  [placeholder]="
        (CSRType !== 'Projected' ? 'MAP.PHOTOGRAM.LONGITUDE_ACCURACY' : 'MAP.PHOTOGRAM.X_ACCURACY') | translate"/>
      </mat-form-field>
      <mat-form-field>
        <input matInput style="width:160px;" type="number" class="form-control"  #heightAccuracy (change)="applyAccuracy(undefined, undefined, heightAccuracy.value)"  [placeholder]="
        (CSRType !== 'Projected' ? 'MAP.PHOTOGRAM.HEIGHT_ACCURACY' : 'MAP.PHOTOGRAM.Z_ACCURACY') | translate"/>
      </mat-form-field>
    </div>

    <div class="fdm-big-choice-box">
      <label>{{ 'GENERIC.OPTIONS' | translate }}</label>
      <div>
        <span class="fdm-checkboxes">
          <input id="rollingShutter" type="checkbox" class="fdm-checkbox" [(ngModel)]="currentJob['rollingShutter']" />
          <label for="rollingShutter"></label>
          <small style="margin-top:-6px!important;font-size:12px;">{{ 'MAP.PHOTOGRAM.ROLLING_SHUTTER' | translate }}</small>
        </span>
      </div>
    </div>

    <div *ngIf="!loadingData" class="fdm-big-choice-box">  
      <div style="font-size:16px;text-align:right;">

        <button style="font-size:18px;height:30px;padding:8px 20px;" class="mr-2" mat-raised-button (click)="dialogRef.close()" [matTooltip]="'GENERIC.CANCEL' | translate">
          {{'GENERIC.CANCEL' | translate }}
        </button>

        <button style="font-size:18px;height:30px;" class="ml-2" color="primary" mat-raised-button [disabled]="csvRecords.length === 0 || inValidData" (click)="saveAndApply()" [matTooltip]="'MAP.PHOTOGRAM.APPLY' | translate">
          {{'MAP.PHOTOGRAM.APPLY' | translate }}
        </button>
           
      </div>
    </div>
     
  </div>
  <div class="col-7">
    <div class="fdm-big-choice-box">
      <label *ngIf="!data.isReference">{{ 'MAP.PHOTOGRAM.IMAGES' | translate }}</label>
      <label *ngIf="data.isReference">{{ 'MAP.PHOTOGRAM.GCP' | translate }}</label>
         <!-- <span *ngIf="this.currentJob['CsvCoordsXYFlipped']">(XY flipped)</span> -->
        <span translate class="fdm-checkboxes float-right" *ngIf="currentJob['COORD_FILE']">
          <input id="latlong" type="checkbox" class="fdm-checkbox" [(ngModel)]="currentJob['latLongSwap']" (change)="latLongSwapping()" />
          <label for="latlong"></label>
          <small style="margin-top:-16px!important;">MAP.PHOTOGRAM.REVERSE_ORDER</small>
        </span>
      
      <div *ngIf="loadingData">
        <mat-spinner style="left: 40%;" ></mat-spinner>
      </div>

      <!-- long={{ longitude.value }} lat={{ latitude.value }}
      <textarea style="width:100%;height:220px;font-size:9px;">{{ [ headersRowColumns ] | json }}</textarea> -->
      <!-- <textarea style="width:100%;height:90px;font-size:9px;">{{ this.currentJob['importedRowXYZ'] | json }}</textarea>  -->

      <div style="max-height: 440px !important; overflow: overlay;width:100%;height:100%;border:solid 1px #aaa;margin-bottom:30px;" 
        *ngIf="!loadingData && headersRowColumns && headersRowColumns.length > 0">
        
        <table class="fdm-sidebar-table-list table-hover" style="width:100%;margin:-5px;">

          <ng-container *ngIf="columnHeaders && columnHeaders.length > 0">
            <tr>
              <ng-container *ngFor="let data of columnHeaders;let j=index">
                <th style="padding:4px !important" [class.fdm-center]="j > 3" [class.item-highlight]="currentJob['latLongSwap'] && ( j == 1 || j == 2 )">
                  {{ data }}
                  <!--{{data}}-->
                <!-- <mat-form-field class="fdm-table-field">
                  <mat-select [disabled]="DATA_FROM_FOLDER" #data [ngModel]="headersRowColumns[j]" (selectionChange)="headerSwitch($event,j)">
                    <mat-option *ngFor="let d of headersRowColumns" [value]="d">
                      {{d.value}}
                    </mat-option>
                  </mat-select>
                </mat-form-field> -->
                </th>
              </ng-container>
            </tr>
          </ng-container>
    
          <ng-container *ngFor="let csvRec of csvRecords;let i=index">
            <tr style="padding: 0rem;">
              <ng-container *ngFor="let data of csvRec;let j=index">
                <td>{{data}} </td>
              </ng-container>
            </tr>
          </ng-container>
    
        </table>
    
      </div>
      
    </div>
  </div>


</div>
